// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"Jumbotron_jumbotron__-cxEF","title":"Jumbotron_title__32FaA","subtitle":"Jumbotron_subtitle__1CmRb"};